import { AuthProviderIdentifier } from "../../../login/AuthProviderIdentifier.js";
import { ThirdPartyCientAuthData } from "../../../login/data/LoginData.js";
import { LoginProvider } from "../LoginProvider.js";


abstract class FBManualFlowCommons implements LoginProvider {

    protected readonly useScopes: string[];
    constructor(scopes: string[]) {
        this.useScopes = scopes && scopes.length > 0?scopes:this.defaultFbScopes;
    }
    

    abstract preloadAction(): Promise<void>;
    abstract getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData>;
    abstract promptLogin(): Promise<ThirdPartyCientAuthData>;
    abstract oneTapLogin(): Promise<ThirdPartyCientAuthData>;
    abstract eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean>;
    public niceName: string  = "Facebook";
    public supportsAutoLogin: boolean = true;
    public useOwnLoginPrompt: boolean = true;
    public providerId: AuthProviderIdentifier = AuthProviderIdentifier.FACEBOOK;
    public supportsOneTap: boolean = false;
    public defaultFbScopes: string[] = ["public_profile", "email", "user_birthday", "user_gender"];

    protected proxyMethodNames = {
        getSessionDataForAutologin: "FB.getSessionDataForAutologin",
        promptLogin: "FB.promptLogin",
        oneTapLogin: "FB.oneTapLogin",
        eventuallyHandleRevoke: "FB.eventuallyHandleRevoke"
    };
}


export { FBManualFlowCommons };